import { useState, useEffect } from 'react';
import { useAdminApiService } from './useAdminApiService';
import { apiService } from '../services/apiService';

/**
 * Reads admin SAGEMASTER.enabled from the backend so analytics modals can hide Sagemaster when disabled.
 */
export function useSagemasterEnabled(mode: 'admin' | 'retail'): boolean {
  const [enabled, setEnabled] = useState(false);
  const { getTradingProviderStatus } = useAdminApiService();

  useEffect(() => {
    let cancelled = false;

    async function load() {
      try {
        if (mode === 'admin') {
          const response = await getTradingProviderStatus();
          if (cancelled) return;
          const flag = response.data?.providers?.SAGEMASTER?.enabled;
          setEnabled(flag === true || flag === 'true');
        } else {
          const response = await apiService.get<{ sagemasterEnabled: boolean }>(
            '/api/retail/trading/providers/exchange-info'
          );
          if (cancelled) return;
          setEnabled(Boolean(response.data?.sagemasterEnabled));
        }
      } catch {
        if (!cancelled) setEnabled(false);
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, [mode, getTradingProviderStatus]);

  return enabled;
}
